import { render, staticRenderFns } from "./JobHoldAction.vue?vue&type=template&id=0bb60468"
import script from "./JobHoldAction.vue?vue&type=script&lang=ts"
export * from "./JobHoldAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports